import styled, { css } from 'styled-components';
import { devices } from './viewports.styles';
import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { AnimatedButton } from '../animation/ButtonAnimations';
import { Step } from '../views/Step';
import { animationCss } from '../animation/Animations.styles';
import { Flow } from 'signup-constants/Flow';
import { getStepConfig } from '../views/getStepConfig';
import UIIllustration from 'UIComponents/image/UIIllustration';

const getButtonColumnCountEmbedded = currentStep => {
  const stepConfig = getStepConfig(currentStep);
  const stepButtonColumnConfig = stepConfig && stepConfig.stepToButtonColumn;
  return stepButtonColumnConfig && stepButtonColumnConfig.embedded ? stepButtonColumnConfig.embedded : 1;
};

const getButtonColumnCountDesktop = (currentStep, isEmbedded, isFramedCentredStepLayout) => {
  const stepConfig = getStepConfig(currentStep);
  const stepButtonColumnConfig = stepConfig && stepConfig.stepToButtonColumn;

  if (isEmbedded || isFramedCentredStepLayout) {
    return getButtonColumnCountEmbedded(currentStep);
  }

  return stepButtonColumnConfig ? stepButtonColumnConfig.default : 2;
};

const getButtonColumnCountMobile = (currentStep, isEmbedded, isFramedCentredStep) => {
  const stepConfig = getStepConfig(currentStep);
  const stepButtonColumnConfig = stepConfig && stepConfig.stepToButtonColumn;

  if (isEmbedded || isFramedCentredStep) {
    return getButtonColumnCountEmbedded(currentStep);
  }

  return stepButtonColumnConfig && stepButtonColumnConfig.mobile ? stepButtonColumnConfig.mobile : 1;
};

export const getButtonColumnCount = (currentStep, isMobile, isEmbedded, isFramedCentredStepLayout) => {
  if (isMobile) {
    return getButtonColumnCountMobile(currentStep, isEmbedded, isFramedCentredStepLayout);
  }

  if (isEmbedded || isFramedCentredStepLayout) {
    return getButtonColumnCountEmbedded(currentStep);
  }

  return getButtonColumnCountDesktop(currentStep, isEmbedded, isFramedCentredStepLayout);
};
export const ButtonsGridStyled = styled.div.withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridStyled",
  componentId: "sc-7xd3u5-0"
})(["--column-count:", ";@media ", "{--column-count:", ";}--total_columns:calc(var(--column-count) * 2);--span:calc(var(--total_columns) / var(--column-count));display:grid;grid-template-columns:repeat(var(--total_columns),minmax(0,1fr));grid-auto-rows:auto;grid-gap:1rem;& > *{grid-column:span var(--span);", "}", " @media ", "{", "}"], props => props.columnCount || getButtonColumnCountMobile(props.currentStep, props.theme.embedded, props.isFramedCentredStepLayout), devices.desktop, props => props.columnCount || getButtonColumnCountDesktop(props.currentStep, props.theme.embedded, props.isFramedCentredStepLayout), props => props.shouldCenter && `	&:nth-last-child(${props.offset}):nth-child(${props.nthChild}) {
			grid-column: var(--span) / span var(--span);
		}`, props => (props.isFramedCentredStep || props.currentStep === Step.UseCase) && `padding-top: 20px;`, devices.desktop, props => props.currentStep === Step.BusinessGoals && props.flowKey === Flow.Crm && css(["", ""], animationCss));
export const ButtonsGridButtonHolder = styled.div.withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridButtonHolder",
  componentId: "sc-7xd3u5-1"
})(["min-height:", ";min-width:0;display:grid;"], ({
  minHeight
}) => minHeight || '5rem');
export const ButtonsGridButton = styled(AnimatedButton).withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridButton",
  componentId: "sc-7xd3u5-2"
})(["height:100%;p{font-size:17px;font-weight:400;", "}& > div{", "}@media ", "{p{font-size:17px;}&:focus{outline:none;box-shadow:0 0 0 2px ", ";}}@media ", "{p{font-size:17px;}&:focus{outline:none;box-shadow:0 0 0 2px ", ";}}"], props => props.isACQ140Variant && `font-weight: 500;`, props => props.currentStep === Step.UseCase && `flex-direction: column; !important
        gap: 0px; !important
      `, devices.desktop, CALYPSO_MEDIUM, devices.tablet, CALYPSO_MEDIUM);
export const StyledIllustrationContainer = styled.div.withConfig({
  displayName: "ButtonsGridstyles__StyledIllustrationContainer",
  componentId: "sc-7xd3u5-3"
})(["text-align:center;margin-top:20px;"]);
export const StyledIllustration = styled(UIIllustration).withConfig({
  displayName: "ButtonsGridstyles__StyledIllustration",
  componentId: "sc-7xd3u5-4"
})(["width:100px;height:100px;margin-bottom:15px;"]);
export const StyledButtonText = styled.p.withConfig({
  displayName: "ButtonsGridstyles__StyledButtonText",
  componentId: "sc-7xd3u5-5"
})(["", ""], props => props.shouldShowIllustrations && `
    font-weight: 500 !important;
    padding-bottom: 15px;
    `);